export const FullscreenModal = ({ children }) => {
  return (
    <div className="fixed inset-0 bg-[#030711] overflow-y-auto h-full w-full">
      <div className="relative h-full">{children}</div>
    </div>
  );
};
